"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFulfillmentEditorOrderShippedBody = exports.getFulfillmentEditorReadyForPickupBody = exports.getFulfillmentEditorOrderShippedSubject = exports.getFulfillmentEditorReadyForPickupSubject = exports.getFulfillmentOrderShippedBodyTemplate = exports.getFulfillmentReadyForPickupBodyTemplate = exports.getFulfillmentOrderShippedSubject = exports.getFulfillmentReadyForPickupSubject = void 0;
const locales_1 = require("../enums/locales");
const EMPTY_LINE = "<p><br></p>";
const getFulfillmentReadyForPickupSubject = (locale) => {
    const subjects = {
        [locales_1.Locales.EN]: "Your order is ready for pick-up 📦",
        [locales_1.Locales.FR]: "Votre commande est prête pour le ramassage 📦",
        [locales_1.Locales.ES]: "Tu pedido está listo para recoger 📦",
        [locales_1.Locales.DE]: "Ihre Bestellung ist zur Abholung bereit 📦",
    };
    return subjects[locale];
};
exports.getFulfillmentReadyForPickupSubject = getFulfillmentReadyForPickupSubject;
const getFulfillmentOrderShippedSubject = (locale) => {
    const subjects = {
        [locales_1.Locales.EN]: "Your order has shipped 📦",
        [locales_1.Locales.FR]: "Votre commande a été expédiée 📦",
        [locales_1.Locales.ES]: "Tu pedido ha sido enviado 📦",
        [locales_1.Locales.DE]: "Ihre Bestellung wurde versendet 📦",
    };
    return subjects[locale];
};
exports.getFulfillmentOrderShippedSubject = getFulfillmentOrderShippedSubject;
const getFulfillmentReadyForPickupBodyTemplate = ({ locale, hasInstructions, }) => {
    const instructionsLabel = {
        [locales_1.Locales.EN]: "Pick-up instructions:",
        [locales_1.Locales.FR]: "Consignes de ramassage :",
        [locales_1.Locales.ES]: "Instrucciones de recogida:",
        [locales_1.Locales.DE]: "Abholhinweise:",
    };
    const instructions = hasInstructions
        ? EMPTY_LINE + `<p>📝 <strong>${instructionsLabel[locale]}</strong><br>{{Pickup instructions}}</p>`
        : "";
    const bodies = {
        [locales_1.Locales.EN]: `<p>Hi {{First name}},</p>` +
            EMPTY_LINE +
            `<p>Your order is ready for pick-up! Here are the details:</p>` +
            `<p>{{Order details}}</p>` +
            `<p>📍 <strong>Pick-up address:</strong><br>{{Pickup address}}</p>` +
            instructions +
            EMPTY_LINE +
            `<p>Thank you for supporting [OrgName]!</p>`,
        [locales_1.Locales.FR]: `<p>Bonjour {{First name}},</p>` +
            EMPTY_LINE +
            `<p>Votre commande est prête pour le ramassage ! Voici les détails :</p>` +
            `<p>{{Order details}}</p>` +
            `<p>📍 <strong>Adresse de ramassage :</strong><br>{{Pickup address}}</p>` +
            instructions +
            EMPTY_LINE +
            `<p>Merci de votre soutien envers [OrgName] !</p>`,
        [locales_1.Locales.ES]: `<p>Hola {{First name}},</p>` +
            EMPTY_LINE +
            `<p>¡Tu pedido está listo para recoger! Estos son los detalles:</p>` +
            `<p>{{Order details}}</p>` +
            `<p>📍 <strong>Dirección de recogida:</strong><br>{{Pickup address}}</p>` +
            instructions +
            EMPTY_LINE +
            `<p>¡Gracias por tu apoyo a [OrgName]!</p>`,
        [locales_1.Locales.DE]: `<p>Hallo {{First name}},</p>` +
            EMPTY_LINE +
            `<p>Ihre Bestellung ist zur Abholung bereit! Hier sind die Details:</p>` +
            `<p>{{Order details}}</p>` +
            `<p>📍 <strong>Abholadresse:</strong><br>{{Pickup address}}</p>` +
            instructions +
            EMPTY_LINE +
            `<p>Vielen Dank für Ihre Unterstützung von [OrgName]!</p>`,
    };
    return bodies[locale];
};
exports.getFulfillmentReadyForPickupBodyTemplate = getFulfillmentReadyForPickupBodyTemplate;
const getFulfillmentOrderShippedBodyTemplate = (locale) => {
    const bodies = {
        [locales_1.Locales.EN]: `<p>Hi {{First name}},</p>` +
            EMPTY_LINE +
            `<p>Your order has been shipped! Here are the details:</p>` +
            `<p>{{Order details}}</p>` +
            `<p>Thank you for supporting [OrgName]!</p>`,
        [locales_1.Locales.FR]: `<p>Bonjour {{First name}},</p>` +
            EMPTY_LINE +
            `<p>Votre commande a été expédiée ! Voici les détails :</p>` +
            `<p>{{Order details}}</p>` +
            `<p>Merci de votre soutien envers [OrgName] !</p>`,
        [locales_1.Locales.ES]: `<p>Hola {{First name}},</p>` +
            EMPTY_LINE +
            `<p>¡Tu pedido ha sido enviado! Estos son los detalles:</p>` +
            `<p>{{Order details}}</p>` +
            `<p>¡Gracias por tu apoyo a [OrgName]!</p>`,
        [locales_1.Locales.DE]: `<p>Hallo {{First name}},</p>` +
            EMPTY_LINE +
            `<p>Ihre Bestellung wurde versendet! Hier sind die Details:</p>` +
            `<p>{{Order details}}</p>` +
            `<p>Vielen Dank für Ihre Unterstützung von [OrgName]!</p>`,
    };
    return bodies[locale];
};
exports.getFulfillmentOrderShippedBodyTemplate = getFulfillmentOrderShippedBodyTemplate;
const getFulfillmentEditorReadyForPickupSubject = (locale) => {
    const subjects = {
        [locales_1.Locales.EN]: "Your order is ready for pick-up 📦",
        [locales_1.Locales.DE]: "Ihre Bestellung ist abholbereit 📦",
        [locales_1.Locales.FR]: "Votre commande est prête pour le ramassage 📦",
        [locales_1.Locales.ES]: "Tu pedido está listo para recoger 📦",
    };
    return subjects[locale];
};
exports.getFulfillmentEditorReadyForPickupSubject = getFulfillmentEditorReadyForPickupSubject;
const getFulfillmentEditorOrderShippedSubject = (locale) => {
    const subjects = {
        [locales_1.Locales.EN]: "Your order has shipped 📦",
        [locales_1.Locales.DE]: "Ihre Bestellung wurde versandt 📦",
        [locales_1.Locales.FR]: "Votre commande a été expédiée 📦",
        [locales_1.Locales.ES]: "Tu pedido ha sido enviado 📦",
    };
    return subjects[locale];
};
exports.getFulfillmentEditorOrderShippedSubject = getFulfillmentEditorOrderShippedSubject;
const getFulfillmentEditorReadyForPickupBody = ({ locale, orgName, firstName, orderDetails, pickupAddress, pickupInstructions, }) => {
    const bodies = {
        [locales_1.Locales.EN]: `<p>Hi ${firstName},</p>` +
            EMPTY_LINE +
            `<p>Your order is ready for pick-up! Here are the details:</p>` +
            `<p>${orderDetails}</p>` +
            `<p>📍 <strong>Pick-up address:</strong><br>${pickupAddress}</p>` +
            EMPTY_LINE +
            `<p>📝 <strong>Pick-up instructions:</strong><br>${pickupInstructions}</p>` +
            EMPTY_LINE +
            `<p>Thank you for supporting ${orgName}!</p>`,
        [locales_1.Locales.DE]: `<p>Hallo ${firstName},</p>` +
            EMPTY_LINE +
            `<p>Ihre Bestellung ist abholbereit! Hier sind die Details:</p>` +
            `<p>${orderDetails}</p>` +
            `<p>📍 <strong>Abholadresse:</strong><br>${pickupAddress}</p>` +
            EMPTY_LINE +
            `<p>📝 <strong>Abholhinweise:</strong><br>${pickupInstructions}</p>` +
            EMPTY_LINE +
            `<p>Vielen Dank für Ihre Unterstützung von ${orgName}!</p>`,
        [locales_1.Locales.FR]: `<p>Bonjour ${firstName},</p>` +
            EMPTY_LINE +
            `<p>Votre commande est prête pour le ramassage ! Voici les détails :</p>` +
            `<p>${orderDetails}</p>` +
            `<p>📍 <strong>Adresse de ramassage :</strong><br>${pickupAddress}</p>` +
            EMPTY_LINE +
            `<p>📝 <strong>Consignes de ramassage :</strong><br>${pickupInstructions}</p>` +
            EMPTY_LINE +
            `<p>Merci de votre soutien envers ${orgName} !</p>`,
        [locales_1.Locales.ES]: `<p>Hola ${firstName},</p>` +
            EMPTY_LINE +
            `<p>¡Tu pedido está listo para recoger! Estos son los detalles:</p>` +
            `<p>${orderDetails}</p>` +
            `<p>📍 <strong>Dirección de recogida:</strong><br>${pickupAddress}</p>` +
            EMPTY_LINE +
            `<p>📝 <strong>Instrucciones de recogida:</strong><br>${pickupInstructions}</p>` +
            EMPTY_LINE +
            `<p>¡Gracias por tu apoyo a ${orgName}!</p>`,
    };
    return bodies[locale];
};
exports.getFulfillmentEditorReadyForPickupBody = getFulfillmentEditorReadyForPickupBody;
const getFulfillmentEditorOrderShippedBody = ({ locale, orgName, firstName, orderDetails, }) => {
    const bodies = {
        [locales_1.Locales.EN]: `<p>Hi ${firstName},</p>` +
            EMPTY_LINE +
            `<p>Your order has been shipped! Here are the details:</p>` +
            `<p>${orderDetails}</p>` +
            `<p>Thank you for supporting ${orgName}!</p>`,
        [locales_1.Locales.DE]: `<p>Hallo ${firstName},</p>` +
            EMPTY_LINE +
            `<p>Ihre Bestellung wurde versandt! Hier sind die Details:</p>` +
            `<p>${orderDetails}</p>` +
            `<p>Vielen Dank für Ihre Unterstützung von ${orgName}!</p>`,
        [locales_1.Locales.FR]: `<p>Bonjour ${firstName},</p>` +
            EMPTY_LINE +
            `<p>Votre commande a été expédiée ! Voici les détails :</p>` +
            `<p>${orderDetails}</p>` +
            `<p>Merci de votre soutien envers ${orgName} !</p>`,
        [locales_1.Locales.ES]: `<p>Hola ${firstName},</p>` +
            EMPTY_LINE +
            `<p>¡Tu pedido ha sido enviado! Estos son los detalles:</p>` +
            `<p>${orderDetails}</p>` +
            `<p>¡Gracias por tu apoyo a ${orgName}!</p>`,
    };
    return bodies[locale];
};
exports.getFulfillmentEditorOrderShippedBody = getFulfillmentEditorOrderShippedBody;
